import EhrService from '@lifeomic/phc-web-toolkit/src/services/EhrService';
import useServiceAuth from '@lifeomic/phc-web-toolkit/src/hooks/useServiceAuth';
import {
  useActiveProject,
  useNotify,
} from '@lifeomic/phc-web-toolkit/src/hooks';
import { defineMessages, useIntl } from 'react-intl';

const ehrService = new EhrService();

const messages = defineMessages({
  startSuccess: {
    id: 'ehr.ingestions.request.successMessage',
    defaultMessage:
      'Successfully started ingestion.  This may take a few minutes.',
  },
  startFailure: {
    id: 'ehr.ingestions.request.failureMessage',
    defaultMessage: 'Failed to start ingestion',
  },
});

function useRefreshEhrData(patient: fhir.Patient) {
  const { formatMessage } = useIntl();
  const [notify] = useNotify();
  const serviceAuth = useServiceAuth();
  const [activeProject] = useActiveProject();
  return async function () {
    try {
      const identifier = patient?.identifier?.find(identifier => {
        // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
        return identifier.system.startsWith(
          // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
          activeProject.lrn.split('project')[0],
        );
      });
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      const ehrId = identifier.system.split(':').pop().split('/')[0];
      const ehrConnectorsResponse = await ehrService.getConnectors(serviceAuth)(
        ehrId,
      );
      const ehrConnectors = ehrConnectorsResponse.data.items;
      const ehrConnector = ehrConnectors.find((connector: any) => {
        return connector.project === activeProject.id;
      });
      const ingestion = {
        connectors: [
          { id: ehrConnector.id, ehrId: ehrId, project: ehrConnector.project },
        ],
        // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
        records: [{ type: 'PATIENT', id: identifier.value }],
      };
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      await ehrService.postIngestion(serviceAuth)(ehrId, ingestion);
      notify(formatMessage(messages.startSuccess), 'success');
    } catch (error) {
      console.error(error);
      notify(formatMessage(messages.startFailure), 'error');
    }
  };
}

export default useRefreshEhrData;
